<div class="container-fluid cards_box main-container col-12 skill-repo-employee-tile" *ngIf="data.length>0">
  <div class="employee-primary-tile card col-3 d-flex flex-column" [class.inActive]="item.isDeleted"
    *ngFor="let item of data">
    <div class="row mt-3 pb-2 pr-4 pl-3 first-compartment ml-2">
      <div class="col-2 p-0">
        <div class="display_align">

          <div>
            <div *ngIf="(item.employeeProfileStatus ==2 ||item.employeeProfileStatus ==0) && !item.isDeleted">
              <h6 style="transform: rotate(-45deg);margin-top: -42px;margin-left: -36px;color: #585858;">Not</h6>
              <br>
            </div>
            <div class="verticalLine1"
              [ngStyle]="(item.employeeProfileStatus ==2 && !item.isDeleted) ? {'margin-top':'-34px'}:{'margin-top':'-25px'}">
            </div>
            <h6 *ngIf="item.employeeProfileStatus ==1 && !item.isDeleted"
              style="transform: rotate(-45deg);margin-top: -45px;margin-left: -38px;color: #036CA7;">Submitted</h6>
            <h6 *ngIf="item.employeeProfileStatus ==3 && !item.isDeleted"
              style="transform: rotate(-45deg);margin-top: -45px;margin-left: -38px;color: #007e3a;">
              &nbsp;<span>Approved</span> </h6>
            <h6 *ngIf="item.employeeProfileStatus ==4 && !item.isDeleted"
              style="transform: rotate(-45deg);margin-top: -45px;margin-left: -38px;color: #E92C2C;"> &nbsp;
              <span>Rejected</span>
            </h6>
            <h6 *ngIf="(item.employeeProfileStatus ==2 ||item.employeeProfileStatus ==0) && !item.isDeleted"
              style="transform: rotate(-45deg);margin-top: -45px;margin-left: -38px;color: #2a2828;">
              &nbsp;<span>Submitted</span></h6>
            <h6 *ngIf="item.isDeleted"
              style="transform: rotate(-45deg);margin-top: -45px;margin-left: -38px;color: rgb(239, 70, 70);">
              &nbsp;<span>Resigned</span></h6>
            <div class="verticalLine2"></div>
          </div>

          <div>
            <span>
              <img class="profile-picture d-block locationimg" width="100%" height="100%"
                src="../../../assets/images/user_avtar.png" />
            </span>
          </div>
        </div>
      </div>
      <div class="col-7 name-holder">

        <div class="d-flex">
          <p class="mb-0 emp-name">{{item.firstName | titlecase}} {{item.lastName | titlecase}}</p>
        </div>
        <div><span class="emp-details"><small class="mb-0">{{item.employeeId}} | {{getExperience(item.experience)}} exp.
              | {{item.grade}}|
              {{getLetters(item.designation)}}</small> </span></div>
        <div>
          <small class="available-colors" *ngIf="item.isAvailable&&!item.isDeleted"> Talent Pool</small>
          <!-- <small class="un-available-colors" *ngIf="item.isDeleted">Resigned</small> -->
          <small (click)="downloadResume(item.id)" class="resume-button"
            [ngStyle]="{'pointer-events': item.isResumeUploaded ? 'auto' : 'none' }">
            <i
              [ngClass]="item.isResumeUploaded ? 'fas fa-check-circle mr-1 success' : 'fas fa-check-circle text-secondary'"></i>
            Resume</small>

        </div>

      </div>

      <div class="icons d-flex flex-column"
        [ngStyle]="(!Leadershiprole && item.employeeProfileStatus == 1 && (Avalibale == 1 && item.isEditable && !item.isDeleted)) ?{ 'margin-left':'-25px'}:{ 'margin-left':'0px'}">
        <div class="d-flex flex-md-row images">
          <div class="edit-icon mr-3 cursor-pointer" *ngIf="item.isEditable">
            <img src="../../../assets/images/edit-icon.svg"
              (click)="navigateToEmpDetails(item.employeeId,false,competency,compId,name,item.isEditable, comingFromGlobalSearch)">
          </div>
          <div class="eye-icon cursor-pointer">
            <img src="../../../assets/images/eye-icon.svg" (click)="openDialog(item.employeeId)" />
          </div>
          <div class="container_chk1 col-1"
            *ngIf="item.employeeProfileStatus == 1 && (Avalibale == 1 && item.isEditable && !item.isDeleted)">
            <input class="checkmark2" type="checkbox" [checked]=" this.isSelectedAll || ischecked(item.employeeId)"
              (change)="onCheckBoxChange($event,item.employeeId)">
            <span *ngIf="!Leadershiprole" class="checkmark1 "></span>
          </div>
        </div>
        <div class="location" [ngStyle]="{'margin-left': item.location.length > 10 ? '0' : '45px'}">
          <small>{{item.location}}</small>
        </div>
        <!-- <div class="Statusicon" *ngIf="cmpId == 3">
          <span class="profileStatus" [style.background-color]="cardColor" [style.color]="cardTextColor"
            [title]="getTooltipText(item?.employeeProfileStatus)">{{cardText}}
          </span>
        </div> -->

      </div>
    </div>
    <hr class="section-divide">
    <div class="m-0 mt-1 pb-2 second-compartment">
      <div class="d-flex col-12">
        <div class="col-3 left-side m-0 pr-0"><small>Email:</small>
        </div>
        <div class="col-9 p-0 sub-head cursor-pointer">
          <small class="competency-name" matTooltip="{{ item.emailAddress}}">{{item.emailAddress}}</small>
        </div>
      </div>
      <div class="d-flex col-12">
        <div class="col-3 left-side m-0 pr-0"><small> Competency :</small></div>
        <div class="col-9 sub-head pl-0 cursor-pointer">
          <div class="competency-list">
            <small
              *ngIf="(comingFromGlobalSearch && !isCompetencyString(item.competencyName)) || (!comingFromGlobalSearch && !isCompetencyString(item.competencyName))"
              class="competency-name" matTooltip="{{getStringWithPipeWithDefaultValue(item.competencyName)}}">
              <span class="defaultCompetency">{{getStringWithPipe(item.competencyName).slice(0,
                getStringWithPipe(item.competencyName).indexOf('|'))}}</span>
              {{getStringWithPipe(item.competencyName).slice(getStringWithPipe(item.competencyName).indexOf('|'))}}
            </small>
            <small
              *ngIf="(comingFromGlobalSearch && isCompetencyString(item.competencyName)) || (!comingFromGlobalSearch && isCompetencyString(item.competencyName))"
              class="competency-name" matTooltip="{{getStringWithPipe(item.competencyName)}}">
              {{getStringWithPipe(item.competencyName)}}
            </small>
          </div>
        </div>
      </div>
      <div class="d-flex col-12">
        <div class="col-3 left-side m-0 pr-0"><small> Sub-Competency :</small></div>
        <div class="col-9 p-0 sub-head cursor-pointer">
          <div class="competency-list">
            <small
              *ngIf="(comingFromGlobalSearch && !isCompetencyString(item.subCompetencyNames)) || (!comingFromGlobalSearch && !isCompetencyString(item.subCompetencyNames))"
              class="competency-name" matTooltip="{{getStringWithPipeWithDefaultValue(item.subCompetencyNames)}}">
              <span
                class="defaultCompetency">{{getStringWithPipe(item.subCompetencyNames).slice(0,getStringWithPipe(item.subCompetencyNames).indexOf('|'))}}</span>
              {{getStringWithPipe(item.subCompetencyNames).slice(getStringWithPipe(item.subCompetencyNames).indexOf('|'))}}
            </small>
            <small
              *ngIf="(comingFromGlobalSearch && isCompetencyString(item.subCompetencyNames)) || (!comingFromGlobalSearch && isCompetencyString(item.subCompetencyNames))"
              class="competency-name" matTooltip="{{getStringWithPipe(item.subCompetencyNames)}}">
              {{getStringWithPipe(item.subCompetencyNames)}}
            </small>
          </div>
        </div>
      </div>
      <div class="d-flex col-12 row-section skill_content">
        <div class="col-3 left-side m-0 pr-0"><small>Skillsets :</small></div>
        <div class="col-9 pl-0 d-flex align-items-center">
          <div class="ellipse-data ellipse_id_data cursor-pointer">
            <div class="chip"
              *ngFor="let skillSet of item.primaryDefaultSkills?item.primaryDefaultSkills.slice(0,3):item.primarySkills.slice(0,3)"
              [matTooltip]="getPrimaryDefaultSkills(item.primaryDefaultSkills?item.primaryDefaultSkills:item.primarySkills)">
              <i class="dot"
                [ngStyle]="{'background-color': skillSet.proficiency==3 ? '#15A055' : ( skillSet.proficiency==2 ? '#FF7A00' : '#9DA9CA') }"></i>
              {{skillSet.skill}}
            </div>
          </div>
          <!-- <div class="readmore_dots" [title]="getPrimaryDefaultSkills(item.primaryDefaultSkills?item.primaryDefaultSkills:item.primarySkills)">•••</div> -->
        </div>
      </div>
    </div>
    <div class="third-compartment" [class.inActive]="item.isDeleted">
      <div class="m-0 mt-1 pb-2">
        <div class="d-flex flex-column">
          <div class="col-12 d-flex row-section">
            <div class="col-3 left-side m-0 pr-0"><small>SME</small></div>
            <div class="col-9 p-0 sub-head cursor-pointer">
              <div class="competency-list">
                <small class="competency-name" matTooltip="{{getStringWithPipe(item.serviceAreaNames)}}">
                  {{ item.serviceAreaNames.length ? getStringWithPipe(item.serviceAreaNames) : 'Not Selected' }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="sub-section-divide">
      <div class="m-0 mt-1 pb-2">
        <div class="d-flex flex-column">
          <div class="d-flex col-12 row-section">
            <div class="col-3 left-side m-0 pr-0"><small>Certifications</small></div>
            <div class="col-9 p-0 sub-head cursor-pointer">
              <div class="competency-list">
                <small class="competency-name" matTooltip="{{getStringWithPipe(item.certifications)}}">
                  {{ item.certifications.length ? getStringWithPipe(item.certifications) : 'No Certification' }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="sub-section-divide">
      <div class="m-0 mt-1 pb-2">
        <div class="d-flex flex-column">
          <div class="d-flex row-section col-12">
            <div class="col-3 left-side m-0 pr-0"><small>Vertical</small></div>
            <div class="col-9 p-0 sub-head cursor-pointer">
              <div class="competency-list">
                <small class="competency-name" matTooltip="{{getStringWithPipe(item.domains)}}">
                  {{ item.domains ? getStringWithPipe(item.domains) : 'Not Selected' }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="data.length == 0" class="empty-section">
    <mat-card>
      <mat-card-content class="no-records">No Records Found</mat-card-content>
    </mat-card>

  </div>